<script setup lang="ts">
import { onMounted } from "vue";
import { useScreenSize } from "../../../utils/useScreenSize";
import DropdownButton from "../common/DropDownButton.vue";
import Buttons from "../form/Buttons.vue";
import { hasPermission } from "../../../utils/CommonFunctions";
import { Permission } from "../../../types/auth";

const { isMobile } = useScreenSize();

const props = withDefaults(
  defineProps<{
    title: string | null;
    readonly: boolean;
    data?: any;
    endPoint: string;
    showDropDown?: boolean;
    permissions?: Permission[];
    showShareIcons?: boolean;
    showSaveIcon?: boolean;
    showText?: boolean;
    showNewIcon?: boolean;
    saveNew?: boolean;
  }>(),
  {
    showText: true,
    showSaveIcon: true,
    showShareIcons: true,
    showNewIcon: true,
    saveNew: false,
  }
);

defineEmits<{
  (e: "clear"): void;
  (e: "createTracking"): void;
  (e: "assignSalesRep"): void;
  (e: "close"): void;
  (e: "download"): void;
  (e: "save"): void;
  (e: "saveNew"): void;
  (e: "mail"): void;
  (e: "share"): void;
  (e: "print"): void;
  (e: "new"): void;
  (e: "convert"): void;
  (e: "close"): void;
  (e: "viewDownload"): void;
  (e: "viewMail"): void;
  (e: "viewShare"): void;
  (e: "viewPrint"): void;
}>();

onMounted(async () => {});
</script>

<template>
  <div class="p-2 md:p-2 w-full bg-white dark:bg-gray-800 flex-shrink-0 w-full border-b border-gray-200 dark:border-gray-700">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-2">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
        {{ title }}
      </h1>
        </div>
      <div>
        <div class="flex gap-1 max-h-[30px]">          
          <slot name="header"></slot>
        <template v-if="!props.readonly && !isMobile">
          <Buttons
            icon="Plus"
            caption="New"
            @click="$emit('new')"
            v-if="
              hasPermission(props.permissions, 'Create') &&
              props.readonly &&
              props.showNewIcon 
            "
          />
          <slot name="write-buttons"></slot>
          <Buttons
            icon="Share2"
            caption="Save"
            @click="$emit('share')"
            v-if="!props.readonly && props.showShareIcons"
          />
          <Buttons
            icon="Mails"
            caption="Save & Email"
            @click="$emit('mail')"
            v-if="!props.readonly && props.showShareIcons"
          />
          <Buttons
            icon="Download"
            caption="Save & Downlaod"
            @click="$emit('download')"
            v-if="!props.readonly && props.showShareIcons"
          />
          <Buttons
            icon="Printer"
            caption="Save & Print"
            @click="$emit('print')"
            v-if="!props.readonly && props.showShareIcons"
          />
          <Buttons
            icon="Save"
            caption="Save"
            @click="$emit('save')"
            v-if="!props.readonly && (props.showShareIcons || props.showSaveIcon)"
          />
          <Buttons
            icon="FilePlus2"
            caption="Save & New"
            @click="$emit('saveNew')"
            v-if="!props.readonly && props.showShareIcons && props.saveNew"
          />
        </template>
        <template v-else-if="props.readonly && props.showShareIcons && !isMobile">
          <slot name="read-buttons"></slot>
          <Buttons
            icon="Download"
            caption="Download"
            @click="$emit('viewDownload')"
          />
          <Buttons icon="Mails" caption="Email" @click="$emit('viewMail')" />
          <Buttons icon="Share2" caption="Share" @click="$emit('viewShare')" />
          <Buttons icon="Printer" caption="Print" @click="$emit('viewPrint')" />
        </template>
        <DropdownButton class-name="mt-[-5px]" text="" icon="EllipsisVertical" :hide-arrow="true" v-if="showDropDown">
            <slot name="dropdownbuttons"></slot>
          </DropdownButton>
          <Buttons
          id="document-header-close"
          @click="$emit('close')"
          :caption="!isMobile ? (props.data ? 'Close' : 'Cancel') : ''"
          class="h-12 md:h-7"
          icon="LogOut"
        />
        </div>
      </div>
    </div>
  </div>
</template>
